import { ScheduleType } from 'modules/domains/campaign';
import { getIsRecurringScheduleType } from 'modules/campaigns/lib/utils';
import { ScheduleFormState } from '../../../types';
import { RecipientTimeZoneScheduleDateSummary } from './RecipientTimeZoneScheduleDateSummary';
import { ProjectTimeZoneScheduleDateSummary } from './ProjectTimeZoneScheduleDateSummary';
import { ScheduleRecurrenceSummary } from './ScheduleRecurrenceSummary';

export type ConfirmScheduleCampaignContentProps = {
  values: ScheduleFormState;
};

export const SCHEDULE_TYPE_DATE_SUMMARY_MAPPER = {
  [ScheduleType.ProjectTimeZone]: ProjectTimeZoneScheduleDateSummary,
  [ScheduleType.RecipientTimeZone]: RecipientTimeZoneScheduleDateSummary,
};

export const ConfirmScheduleCampaignContent = ({ values }: ConfirmScheduleCampaignContentProps) => {
  const { recurrence, scheduleType } = values;
  const isRecurringScheduleType = getIsRecurringScheduleType(recurrence);
  const ScheduleDateSummary =
    SCHEDULE_TYPE_DATE_SUMMARY_MAPPER?.[scheduleType] ??
    SCHEDULE_TYPE_DATE_SUMMARY_MAPPER?.[ScheduleType.ProjectTimeZone];

  return (
    <>
      <ScheduleDateSummary values={values} />
      {isRecurringScheduleType && (
        <>
          <br />
          <br />
          <ScheduleRecurrenceSummary values={values} />
        </>
      )}
    </>
  );
};
